angular.module('unergie.main')
.factory('OrganizationService', ($rootScope, $state, BoFeaturesService, AuthService, DataAccessRefOrganization) => {
    const orgz = DataAccessRefOrganization.getOrganizations().$promise

    let organizations

    orgz.then((organizationsResult) => {
        organizations = organizationsResult
    })

    const isB2B = (org) => {
        return _.find(organizations, { id: org || AuthService.getOrg() }).type === 'B2B'
    }

    const getServiceOrderOrgz = () => orgz.then((orgList) => {
        return _.map(_.filter(orgList, { handle_service_orders: true }), 'id')
    })

    return {
        getOrgz: () => orgz,
        getServiceOrderOrgz,
        handlesServiceOrders: (org) => getServiceOrderOrgz().then((orgList) => orgList.includes(org)),
        isB2B,
    }
})
